import L10n from "lib/carrot-l10n"
import React, { FC } from "react"
import { RoundedRectangle } from "components/views/atoms/roundedrectangle/RoundedRectangle"
import { H3 } from "@carrotfertility/carotene"
import { RRButtonFooter } from "../atoms/roundedrectangle/RRButtonFooter"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type ConnectInsuranceInfoModuleProps = {
  onClickEnroll: () => void
}

const ConnectInsuranceInfoModule: FC<ConnectInsuranceInfoModuleProps> = ({ onClickEnroll }) => {
  return (
    <>
      <RoundedRectangle backgroundColor="light-gray">
        <H3 variant="dark" stack="tiny">
          {l(`Connect to your health insurance plan and you may get more money back`)}
        </H3>
        <RRButtonFooter onClick={onClickEnroll} outline>
          {l`Add insurance info`}
        </RRButtonFooter>
      </RoundedRectangle>
    </>
  )
}

export { ConnectInsuranceInfoModule }
